require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/es7.symbol.observable.js
// module id = 859
// module chunks = 1